import React, { FunctionComponent, useEffect, useState } from 'react'
import { sanAntonioLatLng } from '../../utils/googlemaps'
import { App, FloatButton, Layout, Tooltip } from 'antd'
import {
  AimOutlined,
  CloseOutlined,
  ExpandAltOutlined,
  LoadingOutlined,
  SettingOutlined
} from '@ant-design/icons'
import ServerStatus from '../../components/ServerStatus/ServerStatus'
import RightSider from './RightSider/RightSider'
import { useLocation, useNavigate } from '@tanstack/react-router'
import { Map, useMap } from '@vis.gl/react-google-maps'
import CustomAdvancedMarkerClusterer from '../../components/Plotters/CustomAdvancedMarkerClusterer/CustomAdvancedMarkerClusterer'
import Layers from './RightSider/Layers/Layers'
import { orange, red } from '@ant-design/colors'
import SearchBar from './SearchBar/SearchBar'
import VehicleWindow from '../../components/VehicleWindow/VehicleWindow'

const { Content } = Layout

interface IProps {
  userId: number
  defaultCenter?: {
    lat: number
    lng: number
  }
}

const MapComponent: FunctionComponent<any> = (props: IProps) => {
  const { defaultCenter, userId } = props

  const [collapsed, setCollapsed] = useState<boolean>(true)

  const navigate = useNavigate()

  const location = useLocation()

  const map = useMap()

  const { notification } = App.useApp()

  const [loading, setLoading] = useState<boolean>(false)

  const [geolocationEnabled, setGeolocationEnabled] = useState<boolean>(false)

  useEffect(() => {
    setGeolocationEnabled(!!navigator.geolocation)
  }, [])

  const handleGeolocation = () => {
    // Try HTML5 geolocation.
    if (navigator.geolocation) {
      setLoading(true)
      navigator.geolocation.getCurrentPosition(
        (position: GeolocationPosition) => {
          console.log('Browser has geolocation:', position)
          const pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
          map?.setCenter(pos)
          notification.success({
            message: 'Geolocation Success',
            description: 'Geolocation is available.'
          })
          setLoading(false)
        },
        (error: GeolocationPositionError) => {
          console.error('Browser has geolocation, other error:', error)
          notification.info({
            message: 'Geolocation Error',
            description: 'Optional: Geolocation is not available.'
          })
          setLoading(false)
        }
      )
    } else {
      // Browser doesn't support Geolocation
      console.error('Browser does not support geolocation')
      notification.error({
        message: 'Geolocation Error',
        description: 'Browser does not support geolocation.'
      })
    }
  }

  return (
    <div style={{ height: '100vh' }}>
      <Layout id={'map-layout'} style={{ height: '100vh' }}>
        <Content id={'map-content'} style={{ position: 'relative' }}>
          <SearchBar />
          <ServerStatus />
          <FloatButton.Group
            shape={'square'}
            style={{
              position: 'absolute'
            }}
          >
            <Tooltip
              placement={'left'}
              title={'Geolocation (optional): Click to center map on your location.'}
            >
              <FloatButton
                type={'default'}
                icon={
                  loading ? (
                    <LoadingOutlined />
                  ) : (
                    <AimOutlined style={{ color: geolocationEnabled ? orange[5] : '' }} />
                  )
                }
                onClick={() => handleGeolocation()}
              />
            </Tooltip>
            <FloatButton
              type={'primary'}
              onClick={() => setCollapsed(!collapsed)}
              icon={collapsed ? <SettingOutlined /> : <CloseOutlined />}
            />
            <FloatButton
              style={{
                backgroundColor: location.pathname === '/map' ? red[5] : ''
              }}
              onClick={() => {
                navigate({ to: location.pathname === '/map' ? '/' : '/map' })
              }}
              icon={location.pathname === '/map' ? <CloseOutlined /> : <ExpandAltOutlined />}
            />
          </FloatButton.Group>
          <Map
            defaultCenter={defaultCenter || sanAntonioLatLng}
            defaultZoom={10}
            gestureHandling={'greedy'}
            disableDefaultUI={true}
            reuseMaps={false}
            mapId={'872d17cd822efd56'}
            clickableIcons={false}
          >
            {/*<VehicleWindow userId={userId} />*/}
            <CustomAdvancedMarkerClusterer userId={userId} />
            <Layers userId={userId} />
          </Map>
        </Content>
        <RightSider collapsed={collapsed} setCollapsed={setCollapsed} />
      </Layout>
    </div>
  )
}

export default MapComponent
